import { motion } from 'framer-motion';

const BlogSection = () => {
  const blogPosts = [
    {
      id: 1,
      title: '会社の沿革、経営者のプロフィールは重要',
      excerpt: '仕事をするときに過去になにをしてきたか重要と思います。会社や経営者は過去にやってきたことと行動の癖のようなものがあります。',
      category: '会社の沿革',
      image: 'https://public.readdy.ai/ai/img_res/078a2e67b8da06ee706de50aa4613620.jpg',
      link: '/blog/company-history-profile',
    },
    {
      id: 2,
      title: '事業計画をつくるのはこんな感じです',
      excerpt: '事業計画をつくるとか言われても？？？？？という人は多いと思いますので、Facebookでシェアした内容の転載しました。',
      category: '事業計画',
      image: 'https://readdy.ai/api/search-image?query=enthusiastic%20business%20owner%20working%20on%20business%20plan%20with%20accountant%20in%20modern%20office%2C%20collaborative%20meeting%20atmosphere%20with%20documents%20and%20laptop%2C%20professional%20business%20consultation%20setting%20with%20natural%20lighting%2C%20corporate%20photography%20emphasizing%20teamwork%20and%20determination&width=800&height=500&seq=blog-002&orientation=landscape',
      link: '/blog/business-planning',
    },
    {
      id: 3,
      title: '複数の収入をもつ',
      excerpt: '複数の収入源を持つことで、経営の安定性が高まります。確定申告における注意点や管理方法について解説します。',
      category: '確定申告',
      image: 'https://readdy.ai/api/search-image?query=multiple%20income%20streams%20concept%20with%20financial%20documents%20and%20calculator%2C%20organized%20tax%20preparation%20materials%20on%20modern%20desk%2C%20professional%20accounting%20workspace%20with%20clean%20aesthetic%2C%20business%20photography%20emphasizing%20financial%20management&width=800&height=500&seq=blog-003&orientation=landscape',
      link: '/blog/multiple-income',
    },
    {
      id: 4,
      title: 'レジ現金管理',
      excerpt: '適切な現金管理は事業運営の基本です。レジの現金管理における重要なポイントと実務的な方法をご紹介します。',
      category: '現金管理',
      image: 'https://readdy.ai/api/search-image?query=modern%20cash%20register%20and%20financial%20management%20system%20in%20retail%20setting%2C%20organized%20point%20of%20sale%20workspace%20with%20clean%20professional%20aesthetic%2C%20business%20technology%20with%20natural%20lighting%2C%20commercial%20photography%20emphasizing%20efficiency%20and%20accuracy&width=800&height=500&seq=blog-004&orientation=landscape',
      link: '/blog/cash-register-management',
    },
    {
      id: 5,
      title: '減価償却',
      excerpt: '減価償却の仕組みと計算方法、税務上の取り扱いについて、わかりやすく解説します。',
      category: '税務',
      image: 'https://readdy.ai/api/search-image?query=depreciation%20concept%20with%20business%20assets%20and%20financial%20calculations%2C%20professional%20accounting%20documents%20on%20modern%20desk%2C%20clean%20office%20environment%20with%20natural%20lighting%2C%20business%20photography%20emphasizing%20financial%20planning%20and%20asset%20management&width=800&height=500&seq=blog-005&orientation=landscape',
      link: '/blog/depreciation',
    },
  ];

  return (
    <section id="blog" className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="inline-block mb-4 px-5 py-2 border border-red/20 bg-red/5 rounded-full">
            <span className="text-red text-[13px] font-medium">BLOG</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            経営コラム
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            経営に役立つ会計・税務の知識をお届けします
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <motion.a
              key={post.id}
              href={post.link}
              onClick={(e) => {
                e.preventDefault();
                if (post.link.startsWith('/#')) {
                  const element = document.getElementById('blog');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                } else {
                  window.REACT_APP_NAVIGATE(post.link);
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }
              }}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 cursor-pointer"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 bg-red text-white px-4 py-1.5 rounded-full text-xs font-medium">
                  {post.category}
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red transition-colors">
                  {post.title}
                </h3>
                <p className="text-gray-600 text-[15px] leading-relaxed mb-6">
                  {post.excerpt}
                </p>
                <div className="flex items-center gap-2 text-red font-medium text-sm group-hover:gap-3 transition-all">
                  <span>続きを読む</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;